module.exports = __webpack_public_path__ + "media/images/logo-64ebe108ba9bc0a72ea9a1ad6a8fa8db.svg";